// ModelHelperクラスを要素として複数のモデルグループを扱うラッパークラス
import * as THREE from 'three/build/three.module';
import { J3ModelHelper } from './J3ModelHelper';

export class J3ModelsWrapper extends EventTarget {
    modelHelpers:Array<J3ModelHelper>;  //ModelHelperの配列（モデルグループ）
    currentModelHelper:J3ModelHelper;   //現在表示中のModelHelper
    id:string = 'none';  //グループID
    tagConnect:boolean = false; // タグと連動するか
    completedGroupNum = 0;  //ロードを完了したモデルグループ

    constructor(top:THREE.Object3D, pModels){
        super();

        this.modelHelpers = new Array<J3ModelHelper>(pModels.length);
        

        // GLTF/GLB形式のモデルデータを読み込む
        let i = 0;
        for (const group of pModels){
            this.id = group.groupid;
            this.tagConnect = group.tagConnect;
            const modelHelper = new J3ModelHelper(group.length, 0, group.modelDir);
            modelHelper.addEventListener('LoadComplete', (evt)=>{this.Loaded(evt)});
            modelHelper.addEventListener('Change', (evt)=>{this.IndexChange(evt)});
            modelHelper.addEventListener('dispose', (evt)=>{this.Disposed(evt)});
            if (i == 0) this.currentModelHelper = modelHelper;  //現在のモデルヘルパー初期値（0）
            //ラッパーオブジェクト（親オブジェクト）の作成
            const wrapper = this.MakeEmptyObject(top, group.position, group.rotation);
            if(group.enable){
                const p = group.position;
                wrapper.position.set(p[0],p[1],p[2]);
                const f = Math.PI/180.0;
                const r = group.rotation;
                wrapper.rotation.set(f*r[0],f*r[1],f*r[2]);
                //console.log('J3ModelWrapper', group.groupid);
                modelHelper.LoadModelData(wrapper, group.data);
                this.modelHelpers[i] = modelHelper;
                i++;
            }
        }

        //this.SelectGroup(0);
    }

    Show(){
        this.currentModelHelper.Show();
    }
    Hide(){
        this.currentModelHelper.Hide();
    }

    Loaded(evt){
        console.log('Loaded');
        this.completedGroupNum++;
        if(this.completedGroupNum == this.modelHelpers.length){
            console.log('All Models Loaded', this.completedGroupNum);
            const event = new CustomEvent('AllModelsLoaded');
            this.dispatchEvent(event);
        }
    }

    IndexChange(evt){
        //console.log('IndexChange', evt.detail.index, evt.detail.isMin, evt.detail.isMax);
        const event = new CustomEvent('ChangeThru', { detail: evt.detail });
        this.dispatchEvent(event);
    }

    MakeEmptyObject(top:THREE.Object3D, pos=[0,0,0], rot=[0,0,0]):THREE.Object3D{
        const wrapper = new THREE.Object3D();
        wrapper.position.set(pos[0], pos[1], pos[2]);
        wrapper.rotation.set(rot[0], rot[2], rot[2]);
        top.add(wrapper);
        return wrapper;
    }

    SelectGroup(index = 0){
        const currentIndex = this.currentModelHelper.currentIndex;
        const currentOpacity = this.currentModelHelper.GetOpacity();
        //const currentOpacity = 1.0;
        //表示するモデルグループを指定
        if(index>=0 && index<this.modelHelpers.length){
            for (let i = 0; i < this.modelHelpers.length; i++) {
                //モデルグループごとに表示・非表示を設定
                if(i == index){
                    this.currentModelHelper = this.modelHelpers[i];
                    this.currentModelHelper.Select(currentIndex);
                    this.modelHelpers[i].SetVisibility(true);
                    this.modelHelpers[i].SetOpacity(currentOpacity);
                }else{
                    this.modelHelpers[i].SetVisibility(false);
                }
            }
        }
    }

    SelectItem(index = 0){
        //現在のグループで表示するモデルを選択
        this.currentModelHelper.Select(index);
    }

    SelectNext(){
        this.currentModelHelper.Next();
    }
    SelectPrev(){
        this.currentModelHelper.Prev();
    }

    Rotate(rotSpeed = [0.0, 0.1, 0.0]){
        if (this.currentModelHelper){
            this.currentModelHelper.Rotate(rotSpeed);
        }
    }

    SetVisibility(visible=true){
        this.currentModelHelper.SetVisibility(visible);
    }

    SetOpacity(opacity=1.0){
        this.currentModelHelper.SetOpacity(opacity);
    }

    DisposeAll(){
        for(const modelHelper of this.modelHelpers){
            modelHelper.DisposeAll();
        }
    }

    Disposed(evt){
        console.log('Model', evt.detailname, 'disposed');
    }

}